<template>
  <div class="w-full border-t border-white bg-[#0b2237] h-[88px] flex items-center pb-6">
    <RouterLink
      :to="{ name: 'EarnView' }"
      class="w-1/5 flex flex-col items-center justify-center h-full rounded-b-lg transition-all duration-300"
      exact-active-class="bg-white bg-opacity-10"
    >
      <img src="../assets/icons/earn.svg" class="w-6 h-8 object-contain" />
      <p class="text-white font-normal text-[10px] leading-3">{{ $t('MenuBar.earn') }}</p>
    </RouterLink>
    <RouterLink
      :to="{ name: 'ShipView' }"
      class="w-1/5 flex flex-col items-center justify-center h-full rounded-b-lg transition-all duration-300"
      exact-active-class="bg-white bg-opacity-10"
    >
      <img src="../assets/icons/ship.svg" class="w-6 h-8 object-contain" />
      <p class="text-white font-normal text-[10px] leading-3">{{ $t('MenuBar.ship') }}</p>
    </RouterLink>
    <div class="flex-1 h-full flex items-center justify-center pt-4">
      <img src="../assets/images/pow_logo.svg" class="h-16">
    </div>
    <RouterLink
      :to="{ name: 'JourneyView' }"
      class="w-1/5 flex flex-col items-center justify-center h-full rounded-b-lg transition-all duration-300"
      exact-active-class="bg-white bg-opacity-10"
    >
      <img src="../assets/icons/journey.svg" class="w-6 h-8 object-contain" />
      <p class="text-white font-normal text-[10px] leading-3">{{ $t('MenuBar.journey') }}</p>
    </RouterLink>
    <RouterLink
      :to="{ name: 'RewardsView' }"
      class="w-1/5 flex flex-col items-center justify-center h-full rounded-b-lg transition-all duration-300"
      exact-active-class="bg-white bg-opacity-10"
    >
      <img src="../assets/icons/rewards.svg" class="w-6 h-8 object-contain" />
      <p class="text-white font-normal text-[10px] leading-3">{{ $t('MenuBar.leaders') }}</p>
    </RouterLink>
    <!-- <RouterLink
      :to="{ name: 'NftView' }"
      class="w-1/6 flex flex-col items-center justify-center h-full rounded-b-lg transition-all duration-300"
      exact-active-class="bg-white bg-opacity-10"
    >
      <div class="flex items-center justify-center relative">
        <div
          class="z-10 rounded-xl px-3 bg-GREEN animate-pulse absolute top-1/2 left-1/2 -translate-x-1/2 -translate-y-1/2"
        >
          <p class="text-xs font-medium">Soon</p>
        </div>
        <img src="../assets/icons/nft.svg" class="w-6 h-8 object-contain blur-sm" />
      </div>
      <p class="text-white font-normal text-[10px] leading-3">{{ $t('MenuBar.nft') }}</p>
    </RouterLink>
    <RouterLink
      :to="{ name: 'SwapsView' }"
      class="w-1/6 flex flex-col items-center justify-center h-full rounded-b-lg transition-all duration-300"
      exact-active-class="bg-white bg-opacity-10"
    >
      <div class="flex items-center justify-center relative">
        <div
          class="z-10 rounded-xl px-3 bg-GREEN animate-pulse absolute top-1/2 left-1/2 -translate-x-1/2 -translate-y-1/2"
        >
          <p class="text-xs font-medium">Soon</p>
        </div>
        <img src="../assets/icons/swaps.svg" class="w-6 h-8 object-contain blur-sm" />
      </div>
      <p class="text-white font-normal text-[10px] leading-3">{{ $t('MenuBar.swaps') }}</p>
    </RouterLink> -->
  </div>
</template>
<script setup></script>
